<template>
	<div>
		<div style="text-align: center">
			<p class="title">微众银行商城</p>
			<p class="content">We更好生活</p>
			<div class="bottom-button" @click="buttonClick">
				+添加到我的小程序
			</div>
			<p class="bot">首次收藏获取50元优惠券</p>
		</div>
		<div class="test_triangle_border" v-show="show">
			<div class="popup" @click="buttonClick">
				<van-icon name="cross" color="#fffff" class="close"/>
				点击选择“添加到我的小程序”，就可以轻松购物啦~
			</div>
		</div>
	</div>
</template>

<script>
	import addApplets from "@/components/addApplets.vue";
	export default {
		props: {
			list: {
				type: Array,
				default: null,
			}
		},
		components: {

		},
		data() {
			return {
				show:false
			};
		},
		methods: {
			buttonClick: function() {
				this.show=true;
			},
			closeapplets: function() {
				this.show=false;
				this.show=!this.show
			},
		},
	};
</script>

<style lang="scss" scoped>
.top {
	width: 200px;
	height: 50px;
	background: #000000;
	color: #ffffff;
	position: relative;
	top: 10px;
	right: 10px;
}

.title {
	font-size: 28px;
	color: #333333;
	font-weight: 600;
	margin-top: 20px;
}

.content {
	font-size: 22px;
	color: #333333;
	margin-top: 5px;
	margin-bottom: 30px;
}

.bot {
	font-size: 22px;
	color: #999999;
	margin-top: 10px;
}

.bottom-button {
	width: 282px;
	height: 62px;
	border: 2px solid #333333;
	border-radius: 31px;
	font-size: 24px;
	color: #333333;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0 auto;
}

.test_triangle_border .popup {
	width: 380px;
	line-height: 40px;
	font-size: 26px;
	background: #111;
	padding: 15px 20px;
	color: #fff;
	border-radius: 15px;
	position: fixed;
	top: 20px;
	right: 15px;
	border: 1px solid #111;
}

.test_triangle_border .popup::before {
	content: '';
	width: 0px;
	height: 0px;
	border-width: 0 20px 20px;
	border-style: solid;
	border-color: transparent transparent #111;
	right: 60px;
	top: -15px;
	position: absolute;
	margin-left: -10px;
}
.close{
	position: absolute;
	top: 15px;
	right: 10px;
}
</style>
